// eslint-disable jsx-a11y/anchor-is-valid
import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './FinePaymentInformation.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import PaymentAmount from './PaymentAmount'
import {
  editFineAction,
  paymentAmountAction,
  addFineAction,
  minPaymentAmountAction,
  caseSotIdAction,
  fineTypeAction,
  receiptDetailAction,
  editFineNumberAction,
} from 'redux/actions'
import BackNextButtons from 'shared/components/BackNextButtons.jsx'
import BackAnchor from '../../../../shared/components/BackAnchor'
import InfoDisplay from '../../FinesList/components/InfoDisplay'

const FinePaymentInformationView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const {
    editFineNumber,
    fineNumber,
    minPaymentAmount,
    paymentAmount,
    paymentAmountFull,
    fines,
    fineOwing,
    caseSotId,
    receiptDetail,
    fineType,
  } = useSelector((state) => state.app)
  const [selectedOption, setSelectedOption] = useState('')
  const [selectedOptionValid, setSelectedOptionValid] = useState('')
  const [paymentAmountValid, setPaymentAmountValid] = useState('')
  const [paymentAmountErrorPart1, setPaymentAmountErrorPart1] = useState('fine_payment_information.payment_amount_error')
  const [paymentAmountErrorNumber, setPaymentAmountErrorNumber] = useState('')
  const [paymentAmountErrorPart2, setPaymentAmountErrorPart2] = useState('')

  const backNextProps = {
    prevText: t('fine_payment_information.back'),
    prevURL:
      editFineNumber !== '' && fines.length > 0
        ? `/${i18n.language}${t('routes.listed_fines')}`
        : `/${i18n.language}${t('routes.fine_info')}`,
    nextText: t('fine_payment_information.continue_to_contact_info'),
    isNextDisabled: false,
  }

  useEffect(() => {
    try {
      if (fineNumber === '' && editFineNumber === '') {
        history.push(`/${i18n.language}${t('routes.fine_info')}`)
      } else {
        let fineData = getPaymentAmount()
        const amount = fineData['paymentAmount'] ? fineData['paymentAmount'] : paymentAmount
        if (amount) {
          setSelectedOption(fineOwing === amount ? 'full' : 'partial')
        }
        dispatch(paymentAmountAction(amount))
        if (editFineNumber) {
          dispatch(minPaymentAmountAction(fineData['minPaymentAmount']))
          dispatch(fineTypeAction(fineData['fineType']))
          dispatch(receiptDetailAction(fineData['receiptDetail']))
          dispatch(caseSotIdAction(fineData['caseSotId']))
        }
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const getPaymentAmount = () => {
    try {
      let fineData = fines.filter((fineInfo) => fineInfo.fineNumber === editFineNumber)
      if (fineData.length > 0 && fineData[0]['paymentAmount'] && fineData[0]['minPaymentAmount']) {
        return fineData[0]
      }
      return ''
    } catch (err) {
      console.log(err)
    }
  }

  const onNext = () => {
    try {
      if (paymentAmountFull === 'final') {
        history.push(`/${i18n.language}${t('routes.contact_info')}`)
      } else {
        if (!selectedOption) {
          setSelectedOptionValid(false)
        }
        // if (selectedOption === 'full' || validateFields()) {
        if (validateFields()) {
          let currentFineNumber = editFineNumber
          if (currentFineNumber === '') {
            const fine = fines.filter((fine) => fine.fineNumber === fineNumber)
            if (fine.length === 1) {
              currentFineNumber = fine[0].fineNumber
              dispatch(editFineNumberAction(currentFineNumber))
            }
          }
          if (currentFineNumber) {
            dispatch(
              editFineAction({
                fineNumber: currentFineNumber,
                fineOwing,
                paymentAmount,
                minPaymentAmount: minPaymentAmount,
                paymentAmountFull: selectedOption,
                caseSotId,
                receiptDetail,
                fineType,
              })
            )
          } else {
            dispatch(
              addFineAction({
                fineNumber,
                fineOwing,
                paymentAmount,
                minPaymentAmount: minPaymentAmount,
                paymentAmountFull: selectedOption,
                caseSotId,
                receiptDetail,
                fineType,
              })
            )
          }
          dispatch(editFineNumberAction(''))
          history.push(`/${i18n.language}${t('routes.contact_info')}`)
        }
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const addAnotherFine = () => {
    if (paymentAmountFull === 'final') {
      history.push(`/${i18n.language}${t('routes.fine_info')}`)
    } else {
      if (!selectedOption) {
        setSelectedOptionValid(false)
      }
      // if (selectedOption === 'full' || validateFields()) {
      if (validateFields()) {
        dispatch(
          addFineAction({
            fineNumber,
            fineOwing,
            paymentAmount,
            minPaymentAmount: minPaymentAmount,
            paymentAmountFull: selectedOption,
            caseSotId,
            receiptDetail,
            fineType,
          })
        )
        localStorage.setItem('addAnotherFineClicked', 'finePayment')
        history.push(`/${i18n.language}${t('routes.fine_info')}`)
      }
    }
  }

  const validateFields = () => {
    try {
      let isAmountValid = false
      if (paymentAmount === '') {
        setPaymentAmountValid(isAmountValid)
      } else {
        isAmountValid = validatePaymentAmount(paymentAmount)
      }
      return isAmountValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validatePaymentAmount = (amountElem) => {
    try {
      let isAmountValid = false
      const regex = RegExp(/^[0-9.]+$/)
      if (amountElem !== '') {
        if (regex.test(amountElem) && amountElem.split('.').length < 3) {
          if (amountElem.includes('.') ? amountElem.split('.').slice(-1)[0].length < 3 : true) {
            if (parseFloat(amountElem) >= parseFloat(minPaymentAmount) && parseFloat(amountElem) <= parseFloat(fineOwing)) {
              isAmountValid = true
              setPaymentAmountErrorNumber('')
            } else {
              setPaymentAmountErrorPart1('fine_payment_information.payment_amount_error_lesser_greater_part1')
              setPaymentAmountErrorNumber(getAmountString(minPaymentAmount))
              setPaymentAmountErrorPart2('fine_payment_information.payment_amount_error_lesser_greater_part2')
            }
          } else {
            setPaymentAmountErrorPart1('fine_payment_information.payment_amount_error_decimal')
            setPaymentAmountErrorNumber('')
            setPaymentAmountErrorPart2('')
          }
        } else {
          setPaymentAmountErrorPart1('fine_payment_information.payment_amount_error_invalid')
          setPaymentAmountErrorNumber('')
          setPaymentAmountErrorPart2('')
        }
      } else {
        setPaymentAmountErrorPart1('fine_payment_information.payment_amount_error')
        setPaymentAmountErrorNumber('')
        setPaymentAmountErrorPart2('')
      }
      setPaymentAmountValid(isAmountValid)
      return isAmountValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const getAmountString = (num) => {
    try {
      return i18n.language === 'en' ? `$ ${num}` : `${num.toString().replace('.', ',')} $`
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <div className="container">
      <BackAnchor />
      <div className="row">
        <div className="col-xs-12">
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h2>{t('fine_payment_information.your_fine_details')}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <p style={{ margin: '0' }}>
            <strong>{t('fine_payment_information.fine_number')}</strong>
          </p>
          <p style={{ margin: '0' }}>{editFineNumber ? editFineNumber : fineNumber}</p>
        </div>
      </div>
      <div className="row" style={{ marginTop: '10px' }}>
        <div className="col-xs-12 col-md-8">
          <p style={{ margin: '0' }}>
            <strong>{t('fine_payment_information.fine_total')}</strong>
          </p>
          <p style={{ margin: '0' }}>{getAmountString(fineOwing)}</p>
        </div>
      </div>
      <div className="row" style={{ marginTop: '10px' }}>
        <div className="col-xs-12 col-lg-8">
          {paymentAmountFull === 'final' ? (
            <InfoDisplay />
          ) : (
            <PaymentAmount
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              selectedOptionValid={selectedOptionValid}
              setSelectedOptionValid={setSelectedOptionValid}
              validatePaymentAmount={validatePaymentAmount}
              paymentAmountErrorPart1={paymentAmountErrorPart1}
              paymentAmountErrorNumber={paymentAmountErrorNumber}
              paymentAmountErrorPart2={paymentAmountErrorPart2}
              paymentAmountValid={paymentAmountValid}
              setPaymentAmountValid={setPaymentAmountValid}
              setIsError={setIsError}
            />
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <div
            className={styles['back_next_margin']}
            style={{ display: 'flex', alignItems: 'center', marginTop: '-30px', marginBottom: '-30px' }}
          >
            <BackNextButtons props={backNextProps} nextOnClick={onNext} />
            <button className={['btn-lg btn-default-transparent']} style={{ marginLeft: '10px' }} onClick={addAnotherFine}>
              {t('fine_payment_information.add_another_fine')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(FinePaymentInformationView)
